<!--
    描述：评价记录
    时间：2022-5-18 11:03:14
    Created by 钱磊
-->
<template>
	<div class="operation-layout evaluate-score-main h100" :class="{ pd0: !routeQuery }">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch('1')" @reset="doRefresh" v-if="!routeQuery" hasMore>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchObj" label-width="120px">
					<el-form-item label="评价项目：" prop="assProject">
						<el-input :placeholder="'请输入评价项目'" clearable v-model="searchObj.assProject"></el-input>
					</el-form-item>
					<el-form-item label="评价人：" prop="assName">
						<el-input :placeholder="'请输入评价人'" clearable v-model="searchObj.assName"></el-input>
					</el-form-item>
					<el-form-item label="被评价人：" prop="beAssName">
						<el-input :placeholder="'请输入被评价人'" clearable v-model="searchObj.beAssName"></el-input>
					</el-form-item>
					<el-form-item label="业务来源：" prop="resource">
						<el-select v-model="searchObj.resource" placeholder="请选择业务来源" clearable>
							<el-option v-for="(item, index) in yyyw" :key="'业务来源' + index" :label="item.sname" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchObj" label-width="120px">
					<el-form-item label="评价时间：" prop="dateArr" class="date-time">
						<el-date-picker
							v-model="searchObj.dateArr"
							type="daterange"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							合计评价记录:<span class="red">{{ searchObj.totalResult }}条</span>
						</div>
						<div class="btnGroups"></div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<vxe-table
								:data="tableObj.tableData"
								:loading="tableObj.loading"
								:border="tableObj.border"
								:resizable="tableObj.resizable"
								:size="tableObj.size"
								:height="tableObj.height"
								highlight-current-row
								highlight-hover-row
								show-overflow="tooltip"
								show-header-overflow="tooltip"
							>
								<vxe-table-column type="seq" title="序号" width="60" align="center"></vxe-table-column>
								<vxe-table-column field="serialNo" title="流水号" width="200" align="center"></vxe-table-column>
								<vxe-table-column field="createDate" title="评价时间" width="160" align="center"></vxe-table-column>
								<vxe-table-column field="assProject" title="评价项目" min-width="160" show-overflow align="center"></vxe-table-column>
								<vxe-table-column field="assName" title="评价方" min-width="160" show-overflow align="center"></vxe-table-column>
								<vxe-table-column field="assRole" title="评价方业务角色" width="120" align="center"></vxe-table-column>
								<vxe-table-column field="beAssName" title="被评价方" min-width="160" show-overflow align="center"></vxe-table-column>
								<vxe-table-column field="beAssRole" title="被评价方业务角色" width="140" align="center"></vxe-table-column>
								<vxe-table-column field="resourceName" title="业务来源" width="100" align="center"></vxe-table-column>
								<vxe-table-column field="totalScore" title="评分" width="80" align="center"></vxe-table-column>
								<vxe-table-column title="操作" min-width="90" align="center">
									<template v-slot="{ row }">
										<el-button type="primary" size="small" round plain class="table-btn" @click="getDetail(row)">
											<svg-icon icon-class="form-details"></svg-icon> 详情
										</el-button>
									</template>
								</vxe-table-column>
							</vxe-table>
						</div>
						<div class="w-table-footer">
							<vxe-pager
								size="mini"
								:current-page="searchObj.currentPage"
								:page-size="searchObj.pageSize"
								:total="searchObj.totalResult"
								class="text-center"
								:page-sizes="[10, 20, 50, 100]"
								:layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump']"
								@page-change="handlePageChange"
							>
							</vxe-pager>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<template v-else>
			<RecordsDetail @close="doSearch"></RecordsDetail>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import RecordsDetail from './components/RecordsDetail'
import { getAssessRecordPageList } from 'api/modules/assessment-system/AssessmentRecords'
export default {
	components: {
		RecordsDetail
	},
	data() {
		return {
			showFilter: true,
			searchObj: {
				assProject: '', // 评价项目
				assName: '', // 评价方名称
				beAssName: '', // 被评价方名称
				resource: '', // 业务系统（码表）
				startDate: '', // 规则名称
				endDate: '', // 评价结束时间
				dateArr: [],
				currentPage: 1, // 当前页码
				pageSize: 10, // 当前每页条数
				totalResult: 0
			},
			// 表格对象
			tableObj: {
				tableData: [],
				loading: false,
				border: true,
				resizable: true,
				size: 'small',
				height: '100%'
			},
			tableShow: true
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchObj')) {
				this.searchObj = JSON.parse(this.$getSessionItem('searchObj'))

				// 移除 避免污染
				this.$removeSessionItem('searchObj')
			}

			if (this.$getSessionItem('currentPage')) {
				this.currentPage = JSON.parse(this.$getSessionItem('currentPage'))

				// 移除 避免污染
				this.$removeSessionItem('currentPage')
			}

			if (this.$getSessionItem('pageSize')) {
				this.pageSize = JSON.parse(this.$getSessionItem('pageSize'))

				// 移除 避免污染
				this.$removeSessionItem('pageSize')
			}
			if (this.$getSessionItem('detailData')) {
				// 移除 避免污染
				this.$removeSessionItem('detailData')
			}
		}
		this.doSearch()
	},
	methods: {
		// 评价记录分页列表
		doSearch(page) {
			if (page) {
				this.searchObj.pageSize = 10
				this.searchObj.currentPage = 1
			}
			if (this.searchObj.dateArr && this.searchObj.dateArr.length > 0) {
				this.searchObj.startDate = this.searchObj.dateArr[0] + ' 00:00:00'
				this.searchObj.endDate = this.searchObj.dateArr[1] + ' 23:59:59'
			} else {
				this.searchObj.startDate = ''
				this.searchObj.endDate = ''
			}
			let params = {
				size: this.searchObj.pageSize, // 当前每页条数
				current: this.searchObj.currentPage, // 当前页码
				assProject: this.searchObj.assProject, // 评价项目
				assName: this.searchObj.assName, // 评价方名称
				beAssName: this.searchObj.beAssName, // 被评价方名称
				resource: this.searchObj.resource, // 业务系统（码表）
				startTime: this.searchObj.startDate, // 创建时间 -- 开始
				endTime: this.searchObj.endDate // 创建时间 -- 结束
			}
			this.tableObj.loading = true
			getAssessRecordPageList(params)
				.then((res) => {
					this.tableObj.loading = false
					if (res.operationCode === 1) {
						this.tableObj.tableData = res.data.records
						this.searchObj.totalResult = parseInt(res.data.total)
						this.tableObj.tableData.forEach((item) => {
							let _item = this.yyyw.filter((val) => {
								return val.value == item.resource
							})
							item.resourceName = _item[0].sname //评价应用码表转名称
						})
					}
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},
		// 查看评价记录详情
		getDetail(row) {
			// 存值
			this.$setSessionItem('searchObj', JSON.stringify(this.searchObj))
			this.$setSessionItem('currentPage', JSON.stringify(this.searchObj.currentPage))
			this.$setSessionItem('pageSize', JSON.stringify(this.searchObj.pageSize))
			// 数据
			this.$setSessionItem('detailData', JSON.stringify(row))

			this.$router.push({
				path: '/assessment-records',
				query: {
					type: 'detail',
					id: row.id
				}
			})
		},

		// 切换状态
		changeState() {
			this.showFilter = !this.showFilter
		},

		//刷新/重置
		doRefresh() {
			this.searchObj.pageSize = 10
			this.searchObj.currentPage = 1
			this.searchObj.assProject = ''
			this.searchObj.assName = ''
			this.searchObj.beAssName = ''
			this.searchObj.resource = ''
			this.searchObj.startDate = ''
			this.searchObj.endDate = ''
			this.searchObj.dateArr = []
			this.doSearch()
		},
		// 切换分页
		handlePageChange({ currentPage, pageSize }) {
			this.searchObj.currentPage = currentPage
			this.searchObj.pageSize = pageSize
			this.doSearch()
		}
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('app', { isBack: (state) => state.isBack }),
		...mapState('dict', {
			yyyw: (state) => state.yyyw
		})
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		showFilter() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		}
	}
}
</script>

<style lang="less" scoped>
.operation-layout {
	.operation-main {
		.red {
			color: #ff0000;
		}
	}
}
</style>
